import { render, staticRenderFns } from "./ResumeDetails.vue?vue&type=template&id=77fa6ae6&scoped=true&"
import script from "./ResumeDetails.vue?vue&type=script&lang=ts&"
export * from "./ResumeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeDetails.vue?vue&type=style&index=0&id=77fa6ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fa6ae6",
  null
  
)

export default component.exports